import React, { useState } from 'react';

import Context from './index';

const AuthProvider = (props) => {
  let localAuth = JSON.parse(localStorage.getItem("authenticated")) || false;
  const [authenticated, setAuthenticated] = useState(localAuth);
    return (
        <Context.Provider
            value={{
              authenticated,
              setAuthenticated
            }}
        >
            {props.children}
        </Context.Provider>
    );
};

export default AuthProvider;
